"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmarshall = exports.marshall = void 0;
function marshall(data) {
    return data;
}
exports.marshall = marshall;
function unmarshall(data) {
    return data;
}
exports.unmarshall = unmarshall;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5jaGFuZ2VkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3BsdWdpbnMvdW5jaGFuZ2VkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLFFBQVEsQ0FBQyxJQUFZO0lBQ2pDLE9BQU8sSUFBSSxDQUFDO0FBQ2hCLENBQUM7QUFGRCw0QkFFQztBQUNELFNBQWdCLFVBQVUsQ0FBQyxJQUFZO0lBQ25DLE9BQU8sSUFBSSxDQUFDO0FBQ2hCLENBQUM7QUFGRCxnQ0FFQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBtYXJzaGFsbChkYXRhOiBzdHJpbmcpIHtcbiAgICByZXR1cm4gZGF0YTtcbn1cbmV4cG9ydCBmdW5jdGlvbiB1bm1hcnNoYWxsKGRhdGE6IHN0cmluZykge1xuICAgIHJldHVybiBkYXRhO1xufVxuIl19